var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "店体分配添加",
        visible: _vm.dialogVisible,
        width: "500px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            "max-height": "50vh",
            "overflow-y": "auto",
            padding: "15px 30px",
            "background-color": "#f6f6f6"
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "店号", prop: "shop_no" } },
                [
                  _c("el-input", {
                    on: { input: _vm.onInputShopNo },
                    model: {
                      value: _vm.form.shop_no,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "shop_no", $$v)
                      },
                      expression: "form.shop_no"
                    }
                  }),
                  _c("el-row", [_c("span", [_vm._v(_vm._s(_vm.desc1))])])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "会员编号", prop: "user_number" } },
                [
                  _c("el-input", {
                    on: { input: _vm.onInputUserNumber },
                    model: {
                      value: _vm.form.user_number,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "user_number", $$v)
                      },
                      expression: "form.user_number"
                    }
                  }),
                  _c("el-row", [_c("span", [_vm._v(_vm._s(_vm.desc2))])])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "比例(0-100)", prop: "bili" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.bili,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "bili", $$v)
                      },
                      expression: "form.bili"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.clickSubmit } },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }